// Country-specific SEO landing pages content for "Import from China to X"
export const COUNTRIES = [
  {
    slug: "nigeria",
    country: "Nigeria",
    demonym: "Nigerian",
    flag: "🇳🇬",
    city: "Lagos",
    port: "Apapa & Tin Can Island Ports, Lagos",
    image: "https://images.pexels.com/photos/15674629/pexels-photo-15674629.jpeg",
    seoTitle: "Import from China to Nigeria | Sourcing & Shipping to Lagos — Unicorn Valley Group",
    seoDescription:
      "End-to-end China sourcing and shipping to Nigeria. Verified factories, SONCAP & Form M handling, sea/air freight to Lagos, and door-to-door delivery with full customs clearance.",
    intro:
      "Nigeria is West Africa's largest import market — and importing from China the right way means avoiding fraud, port delays and SONCAP headaches. We handle sourcing, quality control and door-to-door logistics into Lagos so your goods clear smoothly.",
    transit: { sea: "28–38 days", air: "6–10 days", express: "4–7 days" },
    duties: "Import duty + 7.5% VAT typically apply. We help you estimate landed cost before you commit.",
    popularCategories: ["Electronics & Phones", "Generators & Solar", "Apparel & Textiles", "Building Materials", "Auto Parts", "Cosmetics & FMCG"],
    compliance: [
      { title: "SONCAP Certificate", desc: "Product Certificate + SONCAP Certificate required for regulated goods. We arrange conformity testing during production." },
      { title: "Form M & PAAR", desc: "Form M must be opened before shipment; PAAR (Risk Assessment Report) issued by Customs. We guide your bank documentation." },
      { title: "Standards (SON)", desc: "Standards Organisation of Nigeria approval for applicable categories — handled before goods leave China." },
    ],
    faqs: [
      { q: "How long does shipping from China to Lagos take?", a: "Sea freight typically takes 28–38 days port-to-port, air freight 6–10 days, and express 4–7 days. Door-to-door timelines depend on customs clearance." },
      { q: "Do you handle SONCAP and Form M?", a: "Yes. We arrange SONCAP conformity during production and guide your Form M and PAAR documentation so clearance at Apapa/Tin Can is smooth." },
      { q: "Can you ship a full container to Nigeria?", a: "Absolutely — we handle both LCL (shared container) and FCL (full container) shipments, including consolidation of multiple suppliers." },
    ],
    testimonial: { quote: "Verified factories, clear pricing, and our containers arrive in Lagos on schedule every time. SONCAP is no longer a nightmare.", name: "Adaeze Okonkwo", role: "Founder, Lagos Retail Co." },
  },
  {
    slug: "ghana",
    country: "Ghana",
    demonym: "Ghanaian",
    flag: "🇬🇭",
    city: "Tema / Accra",
    port: "Tema & Takoradi Ports",
    image: "https://images.pexels.com/photos/11666903/pexels-photo-11666903.jpeg",
    seoTitle: "Import from China to Ghana | Sourcing & Shipping to Tema — Unicorn Valley Group",
    seoDescription:
      "Source and ship from China to Ghana with confidence. Verified suppliers, ICUMS-compliant documentation, sea/air freight to Tema, and full door-to-door customs clearance.",
    intro:
      "From Tema to Accra, Ghanaian importers trust us to source verified products and move them efficiently through ICUMS customs. We manage everything from factory to your warehouse.",
    transit: { sea: "30–40 days", air: "6–10 days", express: "4–7 days" },
    duties: "Import duty, VAT, NHIL and GETFund levies may apply. We provide a landed-cost estimate upfront.",
    popularCategories: ["Construction Materials", "Electronics", "Agro Machinery", "Apparel", "Home & Kitchen", "Cosmetics"],
    compliance: [
      { title: "ICUMS Declaration", desc: "Integrated Customs Management System processing — we prepare accurate classification and valuation documents." },
      { title: "Supplier Conformity", desc: "Pre-shipment inspection and conformity documentation to avoid clearance disputes at Tema." },
      { title: "Standards Authority", desc: "Ghana Standards Authority requirements handled for regulated product categories." },
    ],
    faqs: [
      { q: "How long is shipping from China to Tema?", a: "Sea freight is roughly 30–40 days, air freight 6–10 days. We provide tracking from departure to delivery." },
      { q: "Do you assist with ICUMS clearance?", a: "Yes, we prepare compliant documentation and work with clearing partners so your cargo moves quickly through Tema." },
      { q: "What is the minimum order?", a: "There's no fixed minimum — we consolidate smaller orders via LCL and handle full containers for larger volumes." },
    ],
    testimonial: { quote: "They source and ship with zero surprises. The team feels like an extension of our company.", name: "Kwame Mensah", role: "Director, Accra Trade Imports" },
  },
  {
    slug: "kenya",
    country: "Kenya",
    demonym: "Kenyan",
    flag: "🇰🇪",
    city: "Nairobi / Mombasa",
    port: "Mombasa Port",
    image: "https://images.pexels.com/photos/1108101/pexels-photo-1108101.jpeg",
    seoTitle: "Import from China to Kenya | Sourcing & Shipping to Mombasa & Nairobi — Unicorn Valley Group",
    seoDescription:
      "China sourcing and shipping to Kenya made simple. Verified factories, KEBS PVoC & IDF handling, sea/air freight to Mombasa, and door-to-door delivery to Nairobi.",
    intro:
      "Kenyan importers rely on us to source quality goods and navigate KEBS PVoC, the Import Declaration Form and Mombasa clearance. We manage the entire chain from China to Nairobi.",
    transit: { sea: "26–34 days", air: "6–9 days", express: "4–7 days" },
    duties: "Import duty, 16% VAT, IDF and Railway Development Levy may apply. We estimate landed cost in advance.",
    popularCategories: ["Electronics", "Solar & Power", "Construction Hardware", "Textiles", "Agricultural Tools", "Beauty & Personal Care"],
    compliance: [
      { title: "KEBS PVoC", desc: "Pre-Export Verification of Conformity certificate arranged before shipment to avoid Mombasa delays." },
      { title: "IDF (Import Declaration Form)", desc: "We guide IDF processing via KRA's iCMS so your entry is registered correctly." },
      { title: "KRA / iCMS Entry", desc: "Accurate classification and valuation to minimise demurrage at the Port of Mombasa." },
    ],
    faqs: [
      { q: "How long does China to Mombasa shipping take?", a: "Sea freight is approximately 26–34 days, air freight 6–9 days. We share live tracking throughout." },
      { q: "Do you arrange KEBS PVoC?", a: "Yes — we coordinate conformity testing and the PVoC certificate during production so clearance is hassle-free." },
      { q: "Can you deliver to Nairobi door-to-door?", a: "Yes, we handle Mombasa clearance and inland transport to Nairobi and beyond." },
    ],
    testimonial: { quote: "Goods sourced and shipped to Nairobi with no surprises. KEBS and clearance are handled end to end.", name: "Daniel Mwangi", role: "Director, Nairobi Build Supplies" },
  },
  {
    slug: "uae",
    country: "United Arab Emirates",
    demonym: "UAE",
    flag: "🇦🇪",
    city: "Dubai / Abu Dhabi",
    port: "Jebel Ali Port (Dubai)",
    image: "https://images.pexels.com/photos/577210/pexels-photo-577210.jpeg",
    seoTitle: "Import from China to UAE | Sourcing & Shipping to Dubai — Unicorn Valley Group",
    seoDescription:
      "Source and ship from China to the UAE and Dubai. Verified factories, Jebel Ali freight, free-zone & mainland customs, ESMA conformity, and fast door-to-door delivery.",
    intro:
      "Dubai is the trade gateway of the Middle East. Whether importing to a free zone or mainland, we source verified products and move them efficiently through Jebel Ali with full customs support.",
    transit: { sea: "18–26 days", air: "4–7 days", express: "3–5 days" },
    duties: "5% customs duty and 5% VAT typically apply on the mainland; free zones offer duty advantages. We advise the best structure.",
    popularCategories: ["Electronics & Gadgets", "Luxury & Retail Goods", "Building Materials", "Industrial Equipment", "Furniture", "Beauty & Wellness"],
    compliance: [
      { title: "ESMA Conformity", desc: "Emirates Authority for Standardization conformity for regulated products, arranged during manufacturing." },
      { title: "Free Zone vs Mainland", desc: "We advise whether free-zone or mainland import is optimal for your duty and re-export plans." },
      { title: "Customs Documentation", desc: "Accurate HS classification and commercial documentation for smooth Jebel Ali clearance." },
    ],
    faqs: [
      { q: "How fast is shipping from China to Dubai?", a: "Sea freight is around 18–26 days, air freight 4–7 days, express 3–5 days — among the fastest China routes." },
      { q: "Do you support free-zone imports?", a: "Yes. We handle both free-zone and mainland imports and advise on the most cost-effective structure." },
      { q: "Can you re-export from the UAE?", a: "Yes, the UAE is ideal for re-export hubs and we structure logistics accordingly." },
    ],
    testimonial: { quote: "Their audits saved us from a costly mistake. QC reports are detailed and genuinely trustworthy.", name: "Fatima Al-Mansoori", role: "Procurement Lead, Dubai" },
  },
  {
    slug: "uk",
    country: "United Kingdom",
    demonym: "UK",
    flag: "🇬🇧",
    city: "London / Felixstowe",
    port: "Felixstowe & Southampton Ports",
    image: "https://images.unsplash.com/photo-1498049794561-7780e7231661?crop=entropy&cs=srgb&fm=jpg&q=85",
    seoTitle: "Import from China to UK | Sourcing & Shipping to London — Unicorn Valley Group",
    seoDescription:
      "China sourcing and shipping to the UK. Verified factories, UKCA marking, EORI & VAT guidance, customs declarations, sea/air freight to Felixstowe, and Amazon FBA prep.",
    intro:
      "Post-Brexit UK importing demands precise documentation. We source verified products, handle UKCA compliance and customs declarations, and deliver to your door or Amazon FBA centre.",
    transit: { sea: "30–40 days", air: "6–9 days", express: "3–6 days" },
    duties: "Import duty (varies by HS code) + 20% VAT. An EORI number is required. We guide the full process.",
    popularCategories: ["Consumer Electronics", "Home & Garden", "Amazon FBA Products", "Fashion & Accessories", "Toys", "Health & Beauty"],
    compliance: [
      { title: "UKCA / CE Marking", desc: "We ensure applicable products carry correct UKCA (or CE) marking and technical files." },
      { title: "EORI & VAT", desc: "Guidance on EORI registration and import VAT so your customs entry is accepted." },
      { title: "Customs Declarations", desc: "Accurate commodity codes and declarations to avoid HMRC holds and penalties." },
    ],
    faqs: [
      { q: "How long is shipping from China to the UK?", a: "Sea freight is about 30–40 days, air freight 6–9 days. We manage customs so delivery is predictable." },
      { q: "Do you prep products for Amazon FBA UK?", a: "Yes — labeling, FNSKU, polybagging and direct delivery into UK fulfillment centres." },
      { q: "Do I need an EORI number?", a: "Yes, a GB EORI is required to import. We guide you through registration if you don't have one." },
    ],
    testimonial: { quote: "From sourcing to FBA prep, they handled everything. Our private label launched two months faster.", name: "James Whitfield", role: "Amazon Brand Owner, UK" },
  },
  {
    slug: "usa",
    country: "United States",
    demonym: "US",
    flag: "🇺🇸",
    city: "Los Angeles / New York",
    port: "Long Beach, LA & New York/NJ Ports",
    image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?crop=entropy&cs=srgb&fm=jpg&q=85",
    seoTitle: "Import from China to USA | Sourcing & Shipping to Los Angeles — Unicorn Valley Group",
    seoDescription:
      "China sourcing and shipping to the USA. Verified factories, ISF (10+2), customs bonds, FDA/CPSC guidance, sea/air freight to LA & NY, and Amazon FBA prep.",
    intro:
      "The US is the world's largest consumer market. We source verified products, manage ISF and customs bonds, and deliver to your door or Amazon FBA — keeping you compliant with CBP, FDA and CPSC.",
    transit: { sea: "18–30 days", air: "5–8 days", express: "3–6 days" },
    duties: "Tariffs vary by HS code (some Section 301 tariffs apply). A customs bond is required. We help estimate landed cost.",
    popularCategories: ["Amazon FBA Products", "Consumer Electronics", "Home & Kitchen", "Apparel", "Sporting Goods", "Pet Supplies"],
    compliance: [
      { title: "ISF (10+2)", desc: "Importer Security Filing submitted before vessel departure to avoid CBP penalties." },
      { title: "Customs Bond", desc: "Single-entry or continuous bond arranged for your imports through US Customs." },
      { title: "FDA / CPSC", desc: "Guidance on FDA (food/cosmetics) and CPSC (consumer product safety) requirements where applicable." },
    ],
    faqs: [
      { q: "How long does China to USA shipping take?", a: "Sea freight to the West Coast is ~18–30 days, air freight 5–8 days. East Coast routes are longer." },
      { q: "Do you handle ISF and customs bonds?", a: "Yes — we file ISF (10+2) on time and arrange the appropriate customs bond for your shipments." },
      { q: "Can you ship directly to Amazon FBA?", a: "Yes, we prep (FNSKU labels, polybags, cartons) and ship directly into US Amazon fulfillment centres." },
    ],
    testimonial: { quote: "The secure payment milestones gave me confidence to scale orders. Best sourcing partner I've worked with.", name: "Sarah Chen", role: "E-commerce Entrepreneur, USA" },
  },
];

export const getCountry = (slug) => COUNTRIES.find((c) => c.slug === slug);
